import { Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/Header";
import Today from "./components/today/Today"
import ExpenseTracker from "./components/expense/ExpenseTracker";
import Planner from "./components/planner/Planner";
import TalkToAI from "./components/ai/TalkToAI";

import ProtectedRoute from "./components/auth/ProtectedRoute";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import Notes from "./components/notes/Notes";
import FileVault from "./components/files/FileVault";

function App() {
  return (
    <div className="ml-[220px] mt-[15vh] p-5">
      <Header />

      <main>
        <Routes>

          {/* -------- PUBLIC ROUTES -------- */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* -------- DEFAULT -------- */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Navigate to="/today" />
              </ProtectedRoute>
            }
          />

          {/* -------- TODAY HOME -------- */}
          <Route
            path="today"
            element={
              <ProtectedRoute>
                <Today />
              </ProtectedRoute>
            }
          />

          {/* -------- FINANCE MODULE -------- */}
          <Route
            path="finance/*"
            element={
              <ProtectedRoute>
                <ExpenseTracker />
              </ProtectedRoute>
            }
          />

          {/* -------- PLANNER MODULE -------- */}
          <Route
            path="planner/*"
            element={
              <ProtectedRoute>
                <Planner />
              </ProtectedRoute>
            }
          />

          {/* -------- AI -------- */}
          <Route
            path="chat"
            element={
              <ProtectedRoute>
                <TalkToAI />
              </ProtectedRoute>
            }
          />

          <Route path="notes/*" element={
            <ProtectedRoute>
              <Notes />
            </ProtectedRoute>
            } />

          <Route path="/files" element={
            <ProtectedRoute>
              <FileVault/>
            </ProtectedRoute>
            } />


        </Routes>
      </main>
    </div>
  );
}

export default App;
